import { Link } from "react-router-dom";

export const SiteFooter = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-cols">
          <div className="site-footer-brand">
            <img src="/bancony300.svg" alt="Bancony" />
            <p>
              Production-grade AI for retail banking, built on the open{" "}
              <a href="https://bank2ai.com" target="_blank" rel="noopener noreferrer">bank2ai</a>{" "}
              standard. Live in weeks.
            </p>
          </div>

          <div className="site-footer-col">
            <h4>Products</h4>
            <ul>
              <li><Link to="/server">Bancony Server</Link></li>
              <li><Link to="/assistant">Bancony Assistant</Link></li>
              <li><Link to="/compliance">Compliance</Link></li>
              <li><a href="https://demo.bancony.com/" target="_blank" rel="noopener noreferrer">Try the demo</a></li>
            </ul>
          </div>

          <div className="site-footer-col">
            <h4>Company</h4>
            <ul>
              <li><Link to="/company">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><a href="mailto:press@bancony.com">Press</a></li>
            </ul>
          </div>

          <div className="site-footer-col">
            <h4>Standard</h4>
            <ul>
              <li><a href="https://bank2ai.com" target="_blank" rel="noopener noreferrer">bank2ai.com</a></li>
              <li><a href="https://bank2ai.com/docs/specification/overview" target="_blank" rel="noopener noreferrer">Spec</a></li>
              <li><a href="https://github.com/bank2ai/bank2ai" target="_blank" rel="noopener noreferrer">GitHub</a></li>
            </ul>
          </div>
        </div>

        <div className="site-footer-support">
          <span className="site-footer-support-label">Supported by</span>
          <a
            href="https://www.rannis.is/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Rannís (Icelandic Centre for Research)"
          >
            <img src="/rannislogo.png" alt="Rannís" className="site-footer-support-logo" />
          </a>
        </div>

        <div className="site-footer-bottom">
          <span>© {new Date().getFullYear()} Bancony ehf. All rights reserved.</span>
          <div className="site-footer-legal">
            <Link to="/legal/privacy">Privacy</Link>
            <Link to="/legal/terms">Terms</Link>
            <Link to="/legal/dpa">DPA</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
